<template>
  <div class="bg-gray p-3">
    <div class="row justify-content-end pr-3">
      <button class="btn btn-outline-pulse" @click="deleteWorkedShiftWithID">
        Shift Verwijderen
      </button>
      <button class="btn btn-outline-pulse" @click="setWorkedShiftToAbsenceWithID">
        Naar Ziekte Omzetten
      </button>
    </div>
    <div class="row justify-content-center">
      <h5>Shift aanpassen</h5>
    </div>

    <ValidationObserver v-slot="{ invalid, handleSubmit }" slim>
      <form @submit.prevent="handleSubmit(save)" class="col-12">
        <div class="form-row align-items-center px-4 py-3">
          <ValidationObserver tag="span" class="form-row align-items-center col-md-8">
            <TimeInputField
                class="form-group col-md-6" v-model="firstShiftLabourStart"
                :id="labourStartHtmlId" labelText="startuur"
                required vid="startTime"/>
            <TimeInputField
                class="form-group col-md-6" v-model="firstShiftLabourEnd"
                :id="labourEndHtmlId" labelText="einduur"
                required :crossFieldRules="['notSame:@startTime']"/>
          </ValidationObserver>
        </div>

        <div class="form-row mx-4 pb-3">
          <div class="input-group">
            <div class="custom-control custom-switch">
              <input
                  type="checkbox" class="custom-control-input"
                  :id="breakCheckedHtmlId"
                  @change="toggleBreakHours" v-model="breakChecked"/>
              <label class="custom-control-label" :for="breakCheckedHtmlId">Pauze genomen?</label>
            </div>
            <div class="custom-control custom-switch ml-3">
              <input
                  type="checkbox" class="custom-control-input"
                  :id="interruptedCheckedHtmlId"
                  @change="toggleInterrupted" v-model="interruptedChecked"/>
              <label class="custom-control-label" :for="interruptedCheckedHtmlId">Onderbroken?</label>
            </div>
            <div class="custom-control custom-switch ml-3">
              <input
                  type="checkbox" class="custom-control-input"
                  :id="calloutCheckedHtmlId"
                  @change="toggleCallout" v-model="calloutChecked"/>
              <label class="custom-control-label" :for="calloutCheckedHtmlId">Oproep?</label>
            </div>
          </div>
        </div>

        <div class="form-row align-items-center py-3">
          <ValidationObserver
              v-show="breakChecked"
              tag="span" class="form-row align-items-center col-md-8">
            <TimeInputField
                class="form-group col-md-6" v-model="firstShiftBreakStart"
                labelText="pauze startuur" :id="breakStartHtmlId"
                vid="breakStartTime" :crossFieldRules="['bothRequiredOrBothNot:@breakEndTime']"/>
            <TimeInputField
                class="form-group col-md-6" v-model="firstShiftBreakEnd"
                labelText="pauze einduur" :id="breakEndHtmlId"
                vid="breakEndTime"
                :crossFieldRules="['bothRequiredOrBothNot:@breakStartTime|notSame:@breakStartTime']"/>
          </ValidationObserver>
          <TextInputField
              labelText="opmerking" class="form-group col-md-4"
              v-model="remark" maxLength="44"/>
        </div>

        <div v-show="calloutChecked" class="form-row align-items-center py-3">
          <ValidationProvider
              tag="div" class="ml-2 d-flex flex-row"
              name="callout"
              v-slot="{ errors }">
            <div class="form-check mr-5">
              <input
                  class="form-check-input" type="radio"
                  :id="noCalloutHtmlId" value=""
                  v-model="calloutValue"/>
              <label class="form-check-label" :for="noCalloutHtmlId">Geen oproep</label>
            </div>
            <div class="form-check mr-5">
              <input
                  class="form-check-input" type="radio"
                  :id="callout24HtmlId" value="CALL_OUT_24"
                  v-model="calloutValue"/>
              <label class="form-check-label" :for="callout24HtmlId">Oproep 24</label>
            </div>
            <div class="form-check">
              <input
                  class="form-check-input" type="radio"
                  :id="callout48HtmlId" value="CALL_OUT_48"
                  v-model="calloutValue"/>
              <label class="form-check-label" :for="callout48HtmlId">Oproep 48</label>
            </div>
            <div class="pl-3 col-lg-8">
              <span class="text-red">{{ errors[0] }}</span>
            </div>
          </ValidationProvider>
        </div>

        <div class="form-row justify-content-center py-3">
          <button
              type="submit" :disabled="invalid"
              class="btn btn-success mr-3">
            Wijzigingen opslaan
          </button>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {ValidationObserver, ValidationProvider} from "vee-validate";
import moment from "moment";
import {toYearAndMonth} from "@/util/DateUtil";
import TextInputField from "@/components/inputFields/TextInputField";
import TimeInputField from "@/components/inputFields/TimeInputField";

export default {
  name: "EditWorkedShiftAdmin",
  components: {
    TimeInputField,
    TextInputField,
    ValidationProvider,
    ValidationObserver
  },
  props: ['rowObject'],
  data() {
    return {
      firstShiftContractName: "",
      firstShiftLabourStart: "",
      firstShiftLabourEnd: "",
      firstShiftBreakStart: "",
      firstShiftBreakEnd: "",
      startDate: "",
      remark: "",
      breakChecked: false,
      interruptedChecked: false,
      calloutChecked: false,
      calloutValue: null,
      contractId: 0,
    };
  },
  computed: {
    ...mapGetters({
      selectedContractId: "administrationTimeSheet/currentlySelectedContractId"
    }),
    labourStartHtmlId: function () {
      return "labourStart" + this.rowObject.date;
    },
    labourEndHtmlId: function () {
      return "labourEnd" + this.rowObject.date;
    },
    breakCheckedHtmlId: function () {
      return "break" + this.rowObject.date;
    },
    interruptedCheckedHtmlId: function () {
      return "interrupted" + this.rowObject.date;
    },
    calloutCheckedHtmlId: function () {
      return "callout" + this.rowObject.date;
    },
    breakStartHtmlId: function () {
      return "breakStart" + this.rowObject.date;
    },
    breakEndHtmlId: function () {
      return "breakEnd" + this.rowObject.date;
    },
    remarkHtmlId: function () {
      return "remark" + this.rowObject.date;
    },
    noCalloutHtmlId: function () {
      return "noCallout" + this.rowObject.date;
    },
    calloutTypeHtmlName: function () {
      return "calloutType" + this.rowObject.date;
    },
    callout24HtmlId: function () {
      return "callout24" + this.rowObject.date;
    },
    callout48HtmlId: function () {
      return "callout48" + this.rowObject.date;
    }
  },
  created() {
    this.fillInForm(this.rowObject.shift);
    if (this.rowObject.shift.breakPeriodStartHours) {
      this.breakChecked = true;
    }

    this.calloutValue = this.rowObject.shift.callout;

    if (this.calloutValue) {
      this.calloutChecked = true;
    }

    this.interruptedChecked = this.rowObject.shift.interrupted;
  },
  methods: {
    ...mapActions("administrationTimeSheet", ['updateWorkedShift', 'deleteWorkedShift', 'updateWorkedShiftToAbsence']),
    save() {
      let _breakPeriod = null;
      if (this.firstShiftBreakStart && this.firstShiftBreakEnd && this.breakChecked) {
        _breakPeriod = {
          startDateTimestamp: this.startDate + 'T' + this.firstShiftBreakStart,
          endDateTimestamp: this.startDate + 'T' + this.firstShiftBreakEnd,
        };
      }

      if (!this.calloutChecked || !this.calloutValue) {
        this.calloutValue = null;
      }

      const workedShiftUpdateDto = {
        day: Number.parseInt(moment(this.startDate).format("DD")),
        idInDay: this.rowObject.idInDayForCustomer,
        callout: this.calloutValue,
        labourPeriod: {
          startDateTimestamp: this.startDate + 'T' + this.firstShiftLabourStart,
          endDateTimestamp: this.startDate + 'T' + this.firstShiftLabourEnd,
        },
        breakPeriod: _breakPeriod,
        shiftTypeId: this.rowObject.shift.shiftTypeId,
        remark: this.remark,
        interrupted: this.interruptedChecked,
      };
      const startDate = moment(this.startDate).toDate();
      const yearMonth = toYearAndMonth(startDate);
      const contractId = this.selectedContractId;
      this.updateWorkedShift({contractId, yearMonth, workedShiftUpdateDto})
          .then(() => this.$emit('shiftsChanged'));
    },
    fillInForm(workedShift) {
      this.startDate = workedShift.startDate;
      this.firstShiftContractName = workedShift.customerName;
      this.firstShiftLabourStart = workedShift.labourPeriodStartHours;
      this.firstShiftLabourEnd = workedShift.labourPeriodEndHours;
      if (workedShift.breakPeriod) {
        this.firstShiftBreakStart = workedShift.breakPeriodStartHours;
        this.firstShiftBreakEnd = workedShift.breakPeriodEndHours;
      } else {
        this.firstShiftBreakStart = "";
        this.firstShiftBreakEnd = "";
      }
      this.remark = workedShift.remark;
      this.contractId = workedShift.contractId;
    },
    deleteWorkedShiftWithID() {
      const yearMonth = toYearAndMonth(this.startDate);
      const day = Number.parseInt(moment(this.startDate).format("DD"));
      const workedShiftDeleteDto = {
        day,
        idInDay: this.rowObject.idInDayForCustomer
      };
      const contractId = this.selectedContractId;
      this.deleteWorkedShift({contractId, yearMonth, workedShiftDeleteDto})
          .then(() => this.$emit('shiftsChanged'));
    },
    setWorkedShiftToAbsenceWithID() {
      const yearMonth = toYearAndMonth(this.startDate);
      const day = Number.parseInt(moment(this.startDate).format("DD"));
      const transformWorkedShiftIntoAbsenceDto = {
        dayOfMonth: day,
        idInDay: this.rowObject.idInDayForCustomer
      };
      const contractId = this.selectedContractId;
      this.updateWorkedShiftToAbsence({contractId, yearMonth, transformWorkedShiftIntoAbsenceDto})
          .then(() => this.$emit('shiftsChanged'));
    },
    toggleBreakHours(arg) {
      this.breakChecked = arg.target.checked;
    },
    toggleInterrupted(arg) {
      this.interruptedChecked = arg.target.checked;
    },
    toggleCallout(arg) {
      this.calloutChecked = arg.target.checked;
    },
  },
};
</script>
<style scoped>

.bg-gray {
  background-color: #EEE;
}

.text-red {
  color: red;
}

</style>